import { extend } from 'underscore'
import AbstractTrigger from '@/ghost/service/Triggers/AbstractTrigger'
import { getPathValue } from '@/common/util/object'

export default class TransactionTrigger extends AbstractTrigger {
  constructor($locator) {
    super($locator, 'getTransaction')
    this.browserRequests = $locator.browserRequests
  }

  /**
   * Get transaction action
   *
   * @method onEvent
   * @param {Action_GetTransaction} getTransactionAction Pay store action
   */
  async onEvent(action) {
    try {
      const response = await this.callGetTransaction(action)
      this.manageResponse(response, action)
    } catch (error) {
      this.onError(error)
    }
  }

  async onError(error, path = 'ghost/service/TransactionTrigger.onEvent') {
    super.onError(error, path)
  }

  async callGetTransaction(action) {
    await super.onEvent(action)
    const { formToken, publicKey, remoteId, paymentMethod, dna } = action
    this.paymentMethod = paymentMethod

    const url = this.restAPI.addJSessionID(
      this.restAPI.getPaymentGetUrl(this.endpoint),
      dna
    )

    const request = this.storeFactory.create('requestData', {
      url,
      objectData: {
        formToken,
        publicKey,
        paymentForm: {
          method: paymentMethod
        },
        remoteId,
        clientVersion: this.restAPI.getClientVersion(),
        device: this.restAPI.getDeviceData(),
        wsUser: this.restAPI.getWSUser()
      },
      headers: {},
      options: {}
    })

    const { response } = await this.browserRequests.post(request)
    if (response.status === 'ERROR')
      throw { metadata: { answer: response.answer } }

    return response
  }

  manageResponse(res, { successfulResponses }) {
    const answer = res.answer
    const transactionStatus =
      answer?.clientAnswer?.transactions[0]?.status.toUpperCase()
    const orderCycle = answer?.clientAnswer?.orderCycle.toUpperCase()

    const prRegex = /^V\d{1}.*\/Charge\/ProcessPaymentAnswer$/

    if (
      prRegex.test(answer._type) &&
      this.isResponseSuccessful(answer?.clientAnswer, successfulResponses)
    ) {
      // Success, complete payment
      const transStore = this.storeFactory.create(
        'billingTransaction',
        extend(answer, {
          rawClientAnswer: JSON.stringify(answer.clientAnswer)
        })
      )

      this.$locator.paymentManager.handler(transStore.json())
      return
    }

    // Unexpected orderCycle or transaction status
    const error = {}
    if (transactionStatus === 'UNPAID') error.metadata = { answer }

    throw error
  }

  isResponseSuccessful(clientAnswer, successfulResponses) {
    return successfulResponses.some(candidate => {
      for (let key in candidate) {
        if (candidate[key] !== getPathValue(clientAnswer, key)) return false
      }
      return true
    })
  }
}
